import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { fetchCompanyAPI } from './companysApi';
import { CompanyState } from '../../types/company';

const initialState: CompanyState = {
  name: null,
  stores: [],
  error: null,
};

/**
 * 会社情報を取得する非同期アクション
 */
export const fetchCompanyData = createAsyncThunk(
  'company/fetchCompanyData',
  async () => {
    try {
      return await fetchCompanyAPI();
    } catch (error) {
      throw error instanceof Error ? error.message : 'An unknown error occurred';
    }
  }
);

const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    setCompany(state, action: PayloadAction<CompanyState>) {
      state.name = action.payload.name;
      state.stores = action.payload.stores;
    },
    clearCompany(state) {
      state.name = null;
      state.stores = [];
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchCompanyData.pending, (state) => {
        state.error = null;
      })
      .addCase(fetchCompanyData.fulfilled, (state, action) => {
        state.name = action.payload.name;
        state.stores = action.payload.stores;
        state.error = null;
      })
      .addCase(fetchCompanyData.rejected, (state, action) => {
        state.error = action.error.message || 'Failed to fetch company data';
      });
  },
});

export const { setCompany, clearCompany } = companySlice.actions;
export default companySlice.reducer;